import { projectQuery } from '../../api-v2/queries/project-query';

export const timelineLoader = (queryClient) => async () => {
  const id = 569;

  queryClient.ensureQueryData(projectQuery({ projectId: id, groupView: true }));

  return { projectId: id };
};
